import Dashboard from "../components/dashboardPage/Dashboard";

const DashboardPage = () => {
    return(
        <Dashboard />
    )
}

export default DashboardPage;